// extracted by mini-css-extract-plugin
export default {"hint":"lsf-hint"};